import type { TenantAuthConfigPublicDto } from '@avila-roffe/api-clients-admin-bff';
import { createContext, useContext } from 'react';

export type TenantStatus = 'loading' | 'ready' | 'not_found' | 'error';

export interface TenantState {
  status: TenantStatus;
  slug: string | null;
  config: TenantAuthConfigPublicDto | null;
  error: string | null;
}

export const TenantContext = createContext<TenantState>({
  status: 'loading',
  slug: null,
  config: null,
  error: null,
});

export function useTenantContext(): TenantState {
  return useContext(TenantContext);
}
